import { render, staticRenderFns } from "./OrderSimpleView.vue?vue&type=template&id=13d53cc4&scoped=true&"
import script from "./OrderSimpleView.vue?vue&type=script&lang=js&"
export * from "./OrderSimpleView.vue?vue&type=script&lang=js&"
import style0 from "./OrderSimpleView.vue?vue&type=style&index=0&id=13d53cc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d53cc4",
  null
  
)

export default component.exports